import { render } from "./CreateFileInsideFeatureAudioSection.vue?vue&type=template&id=67b6ff3e"
import script from "./CreateFileInsideFeatureAudioSection.vue?vue&type=script&lang=js"
export * from "./CreateFileInsideFeatureAudioSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "67b6ff3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b6ff3e', script)) {
    api.reload('67b6ff3e', script)
  }
  
  module.hot.accept("./CreateFileInsideFeatureAudioSection.vue?vue&type=template&id=67b6ff3e", () => {
    api.rerender('67b6ff3e', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/AudioGuide/CreateFileInsideFeatureAudioSection.vue"

export default script